import { effect, Injectable, signal, TemplateRef } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WindowPrinterService {
  readonly isPrinting = signal(false);
  readonly printingTemplate = signal<TemplateRef<any> | null>(null);

  constructor() {
    const printingClass = 'printing';
    effect(() => {
      const printing = this.isPrinting();
      if (printing) {
        document.querySelector('body')?.classList.add(printingClass);
      } else document.querySelector('body')?.classList.remove(printingClass);
    });
  }

  print(template: TemplateRef<any>) {
    this.isPrinting.set(true);
    // this.isPrinting.set(false)
    this.printingTemplate.set(template);
  }
}
